import { render, staticRenderFns } from "./UserMenuAdminPlus.vue?vue&type=template&id=f52b1ec2&scoped=true"
import script from "./UserMenuAdminPlus.vue?vue&type=script&lang=js"
export * from "./UserMenuAdminPlus.vue?vue&type=script&lang=js"
import style0 from "./UserMenuAdminPlus.vue?vue&type=style&index=0&id=f52b1ec2&prod&scoped=true&lang=css"
import style1 from "./UserMenuAdminPlus.vue?vue&type=style&index=1&id=f52b1ec2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f52b1ec2",
  null
  
)

export default component.exports